import React, { useEffect, useState } from "react";
import {
  Code,
  Server,
  Monitor,
  Search,
  ShoppingCart,
  ArrowRight,
} from "lucide-react";
import AOS from "aos";
import "aos/dist/aos.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "../Footer/Footer";
import "../../assets/css/Websitedevelopment.css";
import img1 from "../../assets/image/Appimage/6911675.jpg";
import img2 from "../../assets/image/Websiteimage/10674817.jpg";
import img3 from "../../assets/image/Websiteimage/9080076.jpg";

import {
  FaEnvelope,
  FaSkype,
  FaPhone,
  FaUser,
  FaGlobe,
  FaDollarSign,
  FaChartLine,
  FaPen,
  FaPaperPlane,
  FaBuilding,
  FaTimes,
} from "react-icons/fa";
import { MdOutlineMiscellaneousServices } from "react-icons/md";
import { IoLogoWhatsapp, IoMdBuild } from "react-icons/io";
import emailjs from "@emailjs/browser";
import { useRef } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";

const WebsiteDevelopment = () => {
  const [meta, setMeta] = useState({});

  useEffect(() => {
    const Gamedevelopment = data[0]?.services_page_Website_Developmet;

    if (Gamedevelopment) {
      setMeta(Gamedevelopment);
    }
  }, []);
  const [isOpenEnquiry, setIsOpenEnquiry] = useState(false);

  const [formDataEnquiry, setFormDataEnquiry] = useState({
    name: "",
    email: "",
    phone: "",
    whatsapp: "",
    companyName: "",
    companyService: "",
    serviceType: "",
    country: "",
    message: "",
  });

  const form = useRef();

  const handleClose = () => {
    setIsOpenEnquiry(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataEnquiry((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmitForm = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_z73r4mc",
        "template_evcmg1l",
        form.current,
        "EscxBRJBS9wDUay2E"
      )
      .then(
        (result) => {
          alert("Enquiry sent successfully!");
          setIsOpenEnquiry(false);
          setFormDataEnquiry({
            name: "",
            email: "",
            phone: "",
            whatsapp: "",
            companyName: "",
            companyService: "",
            serviceType: "",
            country: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send enquiry. Please try again.");
        }
      );
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to top-left corner
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  const services = [
    {
      icon: <Code className="w-6 h-6" />,
      title: "Front-End Development",
      description:
        "Building interactive interfaces using Angular, ReactJS, Vue.js, HTML5, CSS3, and modern JavaScript",
      features: ["Angular", "ReactJS", "Vue.js", "HTML5", "CSS3"],
    },
    {
      icon: <Server className="w-6 h-6" />,
      title: "Back-End Solutions",
      description:
        "Utilizing robust platforms like Node.js, PHP, Ruby on Rails, and Python for dynamic content and secure data management",
      features: ["Node.js", "PHP", "Ruby on Rails", "Python"],
    },
    {
      icon: <Monitor className="w-6 h-6" />,
      title: "Responsive Design",
      description:
        "Ensuring seamless performance and aesthetic appeal across desktops, tablets, and mobile devices",
      features: ["Mobile-First", "Cross-Device", "Adaptive Layouts"],
    },
    {
      icon: <Search className="w-6 h-6" />,
      title: "SEO & Analytics",
      description:
        "Implementing best practices for search engine optimization and integrating tools for real-time performance tracking",
      features: [
        "SEO Optimization",
        "Google Analytics",
        "Performance Tracking",
      ],
    },
    {
      icon: <ShoppingCart className="w-6 h-6" />,
      title: "E-commerce & CMS",
      description:
        "Developing full-featured e-commerce platforms and content management systems tailored to your business needs",
      features: ["Shopify", "WordPress", "Custom CMS"],
    },
  ];

  const portfolioItems = [
    {
      title: "E-Shop Platform",
      category: "E-commerce",
      image: img1,
      stats: "100K+ Monthly Visitors",
    },
    {
      title: "Corporate Website",
      category: "Business",
      image: img2,
      stats: "Award-Winning Design",
    },
    {
      title: "Portfolio Site",
      category: "Creative",
      image: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0",
      stats: "50K+ Unique Views",
    },
    {
      title: "Blog Platform",
      category: "Content",
      image: img3,
      stats: "Top 10 CMS Solution",
    },
  ];

  const processSteps = [
    {
      step: "01",
      title: "Concept & Design",
      description:
        "Collaborate to define website goals, user experience, and visual style",
      duration: "2-3 weeks",
    },
    {
      step: "02",
      title: "Prototyping",
      description:
        "Create wireframes and prototypes to test functionality and design",
      duration: "3-4 weeks",
    },
    {
      step: "03",
      title: "Development",
      description:
        "Full-scale development with regular updates and milestone reviews",
      duration: "6-12 weeks",
    },
    {
      step: "04",
      title: "Testing & Launch",
      description:
        "Comprehensive testing, optimization, and deployment across platforms",
      duration: "2-3 weeks",
    },
  ];

  const inputStyle = {
    width: "100%",
    padding: "8px 10px",
    border: "2px solid #e9ecef",
    borderRadius: "10px",
    fontSize: "0.95rem",
    background: "white",
    outline: "none",
    transition: "all 0.3s ease",
  };

  return (
    <HelmetProvider>
      <Helmet>
        <title>
          {meta?.title || "Services-Website_Developmet- SHIV NXTGEN TECHNOLOGIES PRIVATE LIMITED"}
        </title>
        <meta
          name="description"
          content={meta?.meta?.meta1?.content || "Our curriculum."}
        />
      </Helmet>
      <div className="website-development-container">
        {/* Hero Banner Section */}

        {/* Enquiry Form */}
        {isOpenEnquiry && (
          <div
            onClick={handleBackdropClick}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(0, 0, 0, 0.6)",
              backdropFilter: "blur(8px)",
              zIndex: 1050,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                position: "relative",
                width: "100%",
                maxWidth: "650px",
                maxHeight: "100vh",
                background: "#fff",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 15px 50px rgba(0,0,0,0.25)",
              }}
            >
              {/* Fixed Header */}
              <div
                style={{
                  position: "sticky",
                  top: 0,
                  background: "#00b7eb",
                  color: "#ffffff",
                  padding: "15px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  zIndex: 2,
                }}
              >
                <h3
                  style={{
                    margin: 0,
                    fontSize: "1.5rem",
                    fontWeight: "700",
                    textAlign: "center",
                  }}
                >
                  Enquiry Form
                </h3>
                <button
                  onClick={handleClose}
                  style={{
                    background: "transparent",
                    border: "none",
                    color: "#ffffff",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                >
                  <FaTimes />
                </button>
              </div>

              {/* Scrollable Form */}
              <div
                style={{
                  padding: "20px",
                  overflowY: "auto",
                  maxHeight: "calc(100vh - 70px)", // Adjust based on header height
                }}
              >
                <form ref={form} onSubmit={handleSubmitForm}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns:
                        "repeat(auto-fit, minmax(250px, 1fr))",
                      gap: "20px",
                      marginBottom: "20px",
                    }}
                  >
                    {/* Full Name */}
                    <div>
                      <FaUser
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Full Name *</label>
                      <input
                        type="text"
                        name="name"
                        value={formDataEnquiry.name}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter full name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Email */}
                    <div>
                      <FaEnvelope
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Email Address *</label>
                      <input
                        type="email"
                        name="email"
                        value={formDataEnquiry.email}
                        onChange={handleInputChange}
                        required
                        placeholder="Enter email"
                        style={inputStyle}
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <FaPhone
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Phone Number</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formDataEnquiry.phone}
                        onChange={handleInputChange}
                        placeholder="Enter phone"
                        style={inputStyle}
                      />
                    </div>

                    {/* WhatsApp */}
                    <div>
                      <IoLogoWhatsapp
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">WhatsApp</label>
                      <input
                        type="tel"
                        name="whatsapp"
                        value={formDataEnquiry.whatsapp}
                        onChange={handleInputChange}
                        placeholder="Enter WhatsApp"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Name */}
                    <div>
                      <FaBuilding
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        value={formDataEnquiry.companyName}
                        onChange={handleInputChange}
                        placeholder="Enter company name"
                        style={inputStyle}
                      />
                    </div>

                    {/* Company Service */}
                    <div>
                      <IoMdBuild
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Company Service</label>
                      <select
                        name="companyService"
                        value={formDataEnquiry.companyService}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Solo">Solo</option>
                        <option value="Pvt">Pvt</option>
                        <option value="LLP">LLP</option>
                        <option value="Startup">Startup</option>
                        <option value="Partnership">Partnership</option>
                      </select>
                    </div>

                    {/* Service Type */}
                    <div>
                      <MdOutlineMiscellaneousServices
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Type of Service</label>
                      <select
                        name="serviceType"
                        value={formDataEnquiry.serviceType}
                        onChange={handleInputChange}
                        style={inputStyle}
                      >
                        <option value="" disabled>
                          Select
                        </option>
                        <option value="Drone">Drone Solutions</option>
                        <option value="Robotics">Robotics Solutions</option>
                        <option value="IOT">Iot Solutions</option>
                        <option value="AI">Artificial Intelligence</option>
                        <option value="Software">Software Development</option>
                        <option value="App">App Development</option>
                        {/* <option value="Game">Game Development</option> */}
                        <option value="Website">Website Development</option>
                        <option value="AR & VR Development">
                          AR & VR Apps
                        </option>
                        {/* <option value="Casino Api">Casino API</option> */}
                        {/* <option value="Devops Solutions">DevOps</option> */}
                        {/* <option value="It Support">IT Support</option> */}
                        <option value="Training Programs">Training</option>
                        {/* <option value="Digital Marketing">
                          Digital Marketing
                        </option> */}
                      </select>
                    </div>

                    {/* Country */}
                    <div>
                      <FaGlobe
                        style={{
                          color: "#00b7eb",
                          marginRight: "8px",
                          fontSize: "14px",
                        }}
                      />
                      <label className="fw-bold">Country</label>
                      <input
                        type="text"
                        name="country"
                        value={formDataEnquiry.country}
                        onChange={handleInputChange}
                        placeholder="Enter country"
                        style={inputStyle}
                      />
                    </div>
                  </div>

                  {/* Message */}
                  <div>
                    <label className="fw-bold">Your Message *</label>
                    <textarea
                      name="message"
                      value={formDataEnquiry.message}
                      onChange={handleInputChange}
                      required
                      rows={1}
                      placeholder="Tell us about your requirements..."
                      style={{
                        ...inputStyle,
                        resize: "vertical",
                      }}
                    />
                  </div>

                  {/* Submit Button */}
                  <div
                    className="mt-1 margin-top-home"
                    style={{ textAlign: "center" }}
                  >
                    <button
                      type="submit"
                      style={{
                        background: "#00b7eb",
                        color: "white",
                        padding: "10px 20px",
                        borderRadius: "25px",
                        fontWeight: "600",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      <FaPaperPlane style={{ marginRight: "8px" }} />
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}

        <div
          className="position-relative min-vh-50 web-bg d-flex align-items-center justify-content-center bg-dark text-white"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="position-absolute top-0 start-0 w-100 h-100 opacity-20"></div>
          <div className="container position-relative">
            <div className="row align-items-center">
              <div className="col-lg-6 software-content">
                <nav
                  aria-label="breadcrumb"
                  className="mb-4"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-none"
                      >
                        Home
                      </a>
                    </li>
                    <li
                      className="text-white fw-bold breadcrumb-item"
                      aria-current="page"
                    >
                      Website Development
                    </li>
                  </ol>
                </nav>
                <h3
                  className="display-6 fw-bold mb-3"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  Website Development
                </h3>
              </div>
            </div>
          </div>
        </div>
        {/* Main Hero Section */}
        <section className="py-4">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-12 col-lg-6 order-2 order-lg-1 mt-2 mt-lg-0"
                data-aos="fade-right"
              >
                <h3 className="display-5 fw-bold mb-3">
                  Website Development
                  <span className="d-block text-danger">Digital Presence</span>
                </h3>
                <p className="font-para text-dark fw-semibold mb-4">
                  Our Website Development service merges innovative design with
                  powerful functionality to create responsive, SEO-friendly
                  websites that impress and convert. We build dynamic sites that
                  represent your brand and engage your audience effectively.
                </p>
                <div className="d-flex flex-wrap gap-3">
                  <button
                    className="btn btn-red text-white fw-semibold px-4 py-2"
                    onClick={() => setIsOpenEnquiry(true)}
                  >
                    <Code className="me-2" size={18} />
                    Start Your Project
                  </button>
                  {/* <button className="btn btn-red text-white fw-semibold px-4 py-2">
                  View Our Work
                  <ArrowRight className="ms-2" size={18} />
                </button> */}
                </div>
              </div>
              <div
                className="col-12 col-lg-6  d-none d-lg-block  order-1 order-lg-2"
                data-aos="fade-left"
              >
                <img
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f"
                  alt="Website Development"
                  className="img-fluid rounded-4 shadow-lg w-100"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="py-4 bg-light" data-aos="fade-up">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center mb-5">
                <button
                  className=" btn border   border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                  style={{ color: "#00b7eb" }}
                >
                  Our Services
                </button>
                <h3 className="display-5 fw-bold mb-3">
                  Website Development
                  <span className="font-red"> Solutions</span>
                </h3>
                <p className="font-para d-flex fw-semibold col-lg-8 mx-auto">
                  We offer comprehensive website development services,
                  delivering high-performance, user-friendly websites tailored
                  to your business needs.
                </p>
              </div>
            </div>
            <div className="row g-4">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="col-12 col-md-6 mx-auto"
                  data-aos="fade-up"
                  data-aos-delay={`${index * 100}`}
                >
                  <div className="card h-100 border-0 shadow-sm d-flex justify-content-center">
                    <div className="card-body p-3">
                      <div className="d-flex align-items-start mb-3">
                        <div className="bg-danger text-white rounded-3 p-2 me-3">
                          {service.icon}
                        </div>
                        <div>
                          <h4 className="fw-bold mb-2">{service.title}</h4>
                          <p className="font-para fw-semibold mb-2">
                            {service.description}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex flex-wrap gap-2">
                        {service.features.map((feature, idx) => (
                          <span
                            key={idx}
                            className="web-badge px-3 py-2 bg-opacity-10 font-black fw-semibold border rounded"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Portfolio Section */}
        <section className="py-4" data-aos="fade-up">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center mb-5">
                <button
                  className=" btn border
                  border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                  style={{ color: "#00b7eb" }}
                >
                  Our Portfolio
                </button>
                <h3 className="display-5 fw-bold mb-3">
                  Feature <span className="font-red ">Websites</span>{" "}
                </h3>
                <p className="font-para fw-semibold col-lg-8 mx-auto">
                  Explore our portfolio of successful websites that have driven
                  engagement and conversions for businesses worldwide.
                </p>
              </div>
            </div>
            <div className="row g-4">
              {portfolioItems.map((item, index) => (
                <div
                  key={index}
                  className="col-12 col-md-6"
                  data-aos="zoom-in"
                  data-aos-delay={`${index * 100}`}
                >
                  <div className="card bg-dark border-0 shadow-sm h-100">
                    <div className="position-relative">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="card-img-top"
                        style={{ height: "200px", objectFit: "cover" }}
                      />
                      <div className="position-absolute top-0 end-0 m-3">
                        <span className="badge bg-danger fw-semibold text-white">
                          {item.category}
                        </span>
                      </div>
                    </div>
                    <div className="card-body">
                      <h4 className="fw-bold mb-2 text-white">{item.title}</h4>
                      <div className="d-flex justify-content-between align-items-center">
                        <span className="text-white fw-semibold">
                          {item.stats}
                        </span>
                        {/* <button className="btn btn-danger btn-sm px-3">
                        View Details
                      </button> */}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-4 bg-light" data-aos="fade-up">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center mb-5">
                <button
                  className=" btn border  border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                  style={{ color: "#00b7eb" }}
                >
                  Our Process
                </button>
                <h3 className="display-5 fw-bold mb-3">
                  How We Build <span>Websites</span>{" "}
                </h3>
                <p className=" font-para fw-semibold col-lg-8 mx-auto">
                  Our proven development process ensures your website is
                  delivered on time, within budget, and exceeds your
                  expectations.
                </p>
              </div>
            </div>
            <div className="row g-4">
              {processSteps.map((step, index) => (
                <div
                  key={index}
                  className="col-12 col-md-6"
                  data-aos="fade-up"
                  data-aos-delay={`${index * 100}`}
                >
                  <div className="d-flex align-items-center">
                    <div className="rounded-3 p-2 me-4 flex-shrink-0">
                      <span className="text-danger fw-bold">{step.step}</span>
                    </div>
                    <div>
                      <h4 className="text-danger fw-bold mb-2">{step.title}</h4>
                      <p className="font-para fw-semibold mb-2">
                        {step.description}
                      </p>
                      <span className="web-badge-dur px-3 py-2 gap-4 bg-opacity-10  ">
                        {step.duration}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Section */}
        <section className="py-4" data-aos="fade-up">
          <div className="container">
            <div className="row">
              <div className="col-12 text-center mb-5">
                <button
                  className=" btn border border-danger fw-semibold  bg-transparent  px-3 py-2 rounded-pill fs-6 fs-md-5"
                  style={{ color: "#00b7eb" }}
                >
                  Get In Touch
                </button>
                <h3 className="display-5 fw-bold mb-3">
                  Ready to Start Your Website?
                </h3>
                <p className="font-para fw-semibold col-lg-8 mx-auto">
                  Let's discuss your website development project and bring your
                  vision to life. Our team is ready to create a compelling
                  online presence for your brand.
                </p>
              </div>
            </div>
            <div className="row g-4">
              {[
                {
                  icon: <Code size={24} />,
                  title: "Expert Team",
                  description: "Experienced developers and designers",
                },
                {
                  icon: <Server size={24} />,
                  title: "Quality Assured",
                  description: "Rigorous testing and quality control",
                },
                {
                  icon: <Monitor size={24} />,
                  title: "Responsive Design",
                  description: "Seamless performance across all devices",
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="col-12 col-md-4 text-center"
                  data-aos="zoom-in"
                  data-aos-delay={`${index * 100}`}
                >
                  <div className="bg-danger text-white rounded-3 p-3 d-inline-block mb-3">
                    {item.icon}
                  </div>
                  <h5 className="fw-bold">{item.title}</h5>
                  <p className="font-para fw-semibold mb-0">
                    {item.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default WebsiteDevelopment;
